import { ColorsEnum } from "../../et3-theme/colors";

const ALPHA_HAIRLINE = "24";
const ALPHA_TINT = "14";
const ALPHA_FAINT = "0F";

export const RADIO_HEIGHT = 44;
export const RADIO_RADIUS = 12;
export const RADIO_PADDING_X = 16;
export const RADIO_GAP = 10;
export const RADIO_RING_SIZE = 18;
export const RADIO_RING_BORDER_WIDTH = 2;
export const RADIO_DOT_SIZE = 8;
export const RADIO_LABEL_FONT_SIZE = 15;
export const RADIO_MIN_WIDTH = 120;

export const RADIO_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const RADIO_BORDER_SELECTED = `1px solid ${ColorsEnum.bondiBlue}`;
export const RADIO_BACKGROUND_SELECTED = `${ColorsEnum.bondiBlue}${ALPHA_TINT}`;
export const RADIO_SHADOW = `0 1px 2px ${ColorsEnum.maastrichtBlue}${ALPHA_FAINT}`;
export const RADIO_BACKGROUND_HOVER = `${ColorsEnum.maastrichtBlue}0A`;
export const RADIO_RING_COLOR = ColorsEnum.lightGray;

export const RADIO_TRANSITION =
  "background-color 160ms cubic-bezier(0.4, 0, 0.2, 1), border-color 160ms cubic-bezier(0.4, 0, 0.2, 1)";
export const RADIO_GROUP_WIDTH = 450;
export const RADIO_GROUP_HEIGHT = 70;
export const RADIO_GROUP_GAP = 10;
